module.exports = __webpack_public_path__ + "img/car.aa057247.svg";